import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const baseResource = `${MERCATELY_API}/customers`;

const formatNewResource = (webId) => {
  return `${baseResource}/${webId}/customer_addresses`;
}

const model = abstractModel('');

const parentGet = model.get;
const parentSave = model.save;
const parentRemove = model.remove;

model.get = async (webId) => {
  return parentGet({}, { path: formatNewResource(webId) });
};

model.save = async (webId, params) => {
  return parentSave(params, { path: formatNewResource(webId) });
};

model.remove = async (webId, params) => {
  return parentRemove(params, { path: formatNewResource(webId) });
};

model.getOne = async (webId, params) => {
  return model.findById(params.id, {}, { path: formatNewResource(webId) });
};

export default model;
